module.exports = require('./dist/commonjs/advanced');
